import { SUBSCRIPTION } from '@/models/subscriptions';
import store from '@/store/store';

export function tenantIsStandard() {
  const subscriptionType = store.getters['tenant/subscriptionType'];
  return subscriptionType === SUBSCRIPTION.STANDARD;
}

export function tenantIsPrivilege() {
  const subscription = store.getters['tenant/subscriptionType'];
  return subscription === SUBSCRIPTION.PRIVILEGE;
}

export function tenantIsPremium() {
  const subscription = store.getters['tenant/subscriptionType'];
  return subscription === SUBSCRIPTION.PREMIUM;
}

export function tenantIsEssentiel() {
  const subscription = store.getters['tenant/subscriptionType'];
  return subscription === SUBSCRIPTION.ESSENTIEL;
}

export function tenantIsPlus() {
  const subscription = store.getters['tenant/subscriptionType'];
  return subscription === SUBSCRIPTION.PLUS;
}

export function tenantIsPro() {
  const subscription = store.getters['tenant/subscriptionType'];
  return subscription === SUBSCRIPTION.PRO;
}
